import React, { useEffect } from "react";
import "./Experience.css"; // Custom CSS for the Experience component
import AOS from "aos";
import "aos/dist/aos.css";

const lumenImage = "assets/images/lumen.png";
const perugiaImage = "assets/images/perugia.jpg";
const envisionImage = "assets/images/envisionexotics.png";
const emrDirectImage = "assets/images/emrdirect.png";
const proofImage = "assets/images/proof.png";

function Experience() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="experience-container">
      <h1>Experience</h1>
      <div className="timeline">
        <div className="timeline-item" data-aos="fade-up">
          <div className="timeline-content">
            <h2>Software Engineering Co-op, Proof</h2>
            <h4>January 2025 – September 2025</h4>
            <ul>
              <li>
                Led frontend development and contributed to specification and
                backend development of numerous new features to meet customer
                needs:
              </li>
              <ul>
                <li>
                  <em>Cost centers:</em> Custom accounting categories allowing
                  businesses to tag transactions to differentiate them for
                  accounting purposes. Developed creation, editing, and
                  transaction application flow, as well as interactive,
                  searchable table view for all created cost centers.
                </li>

                <li>
                  <em>Brand settings profiles:</em> Enabled businesses to
                  customize branding on customer interaction with our platform
                  relating to their business operations.
                </li>

                <li>
                  <em>Command Center home page:</em> New home page for my team’s
                  flagship product, Command Center, with custom cards enabling
                  users to navigate to different sections of Command Center.
                </li>

                <li>
                  <em>Paginated organizations table:</em> Developed a paginated
                  table for all child organizations and their relationships for
                  root organizations. Created and optimized interactive
                  functionality, allowing users to modify attributes of and
                  relationships between organizations.
                </li>
              </ul>

              <li>
                Wrote comprehensive end-to-end (WebDriver E2E) and unit (Jest)
                tests for new feature work.
              </li>

              <li>
                Cleaned up unused LaunchDarkly flags and display bugs/redux form
                usages across the platform.
              </li>
            </ul>
          </div>
          <div className="timeline-image">
            <img src={proofImage} alt="Proof logo" />
          </div>
        </div>
        <div className="timeline-item" data-aos="fade-up">
          <div className="timeline-content">
            <h2>Software Developer Intern, Lumen Technologies</h2>
            <h4>May 2024 – August 2024</h4>
            <ul>
              <li>
                Maintained complex network routing systems, adapted them to
                consumer network device and route changes.
              </li>

              <li>
                Diagnosed and resolved issues in JSON schema validation
                packages, ensuring accurate processing of customer network
                service requests and improving system reliability.
              </li>

              <li>
                Optimized the performance of scripts transforming network
                service requests into optimal enablement paths.
              </li>

              <li>
                Migrated unit (FitNesse) tests to new lab devices and
                manipulated test databases using robust SQL queries.
              </li>
            </ul>
          </div>
          <div className="timeline-image">
            <img src={lumenImage} alt="Lumen Technologies logo" />
          </div>
        </div>
        <div className="timeline-item" data-aos="fade-up">
          <div className="timeline-content">
            <h2>
              AI Software Development/Research Co-op, University of Perugia
              (Italy)
            </h2>
            <h4>September 2023 – December 2023</h4>
            <ul>
              <li>
                Developed an{" "}
                <a
                  target="_tab"
                  rel="noopener noreferrer"
                  href="https://github.com/iandreafc/distinctiveness-R"
                >
                  {" "}
                  R package
                </a>{" "}
                for computing metrics of Distinctiveness Centrality, a metric to
                interpret graphical data, used in the Semantic Brand Score (SBS)
                Business Intelligence App which conducts semantic analysis of
                text.
              </li>

              <li>
                <a
                  target="_tab"
                  rel="noopener noreferrer"
                  href="https://cran.r-project.org/web/packages/distinctiveness/index.html"
                >
                  Published the package to CRAN
                </a>
                , distributing the package to users in many R development
                environments.
              </li>

              <li>
                Optimized the{" "}
                <a
                  target="_tab"
                  rel="noopener noreferrer"
                  href="https://semanticbrandscore.com/"
                >
                  SBS App
                </a>
                's learning algorithms by implementing parallel processing
                strategies.
              </li>
            </ul>
          </div>
          <div className="timeline-image">
            <img src={perugiaImage} alt="University of Perugia BCI lab logo" />
          </div>
        </div>
        <div className="timeline-item" data-aos="fade-up">
          <div className="timeline-content">
            <h2>Lead Web Developer, Envision Exotics</h2>
            <h4>March 2023 – September 2023</h4>
            <ul>
              <li>
                Created an online shop for exotic car rentals in Miami, FL that
                is still in use today:{" "}
                <a
                  target="_tab"
                  rel="noopener noreferrer"
                  href="https://envisionexotics.com"
                >
                  envisionexotics.com
                </a>
              </li>

              <li>
                Developed functionality for customers to reserve times and dates
                for specific cars in inventory.
              </li>

              <li>
                Built infrastructure to handle payments, security deposits,
                e-signing of rental agreements, and intake and verification of
                driver's licenses and insurance information.
              </li>
            </ul>
          </div>
          <div className="timeline-image">
            <img src={envisionImage} alt="Envision Exotics logo" />
          </div>
        </div>
        <div className="timeline-item" data-aos="fade-up">
          <div className="timeline-content">
            <h2>Software Engineering Intern, EMR Direct</h2>
            <h4>September 2020 – December 2020</h4>
            <ul>
              <li>
                Created web pages for customers to engage with our products in
                HTML/CSS/PHP.
              </li>

              <li>
                Worked on enabling the secure exchange of health records between
                doctors and patients in a national network of hospitals,
                doctors, and patients in conformance with Direct and HL7
                standards.
              </li>
            </ul>
          </div>
          <div className="timeline-image">
            <img src={emrDirectImage} alt="EMR Direct logo" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Experience;
